var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0156 1.03125C10.4471 1.03125 10.7969 1.38103 10.7969 1.8125V11.1875C10.7969 11.619 10.4471 11.9688 10.0156 11.9688H2.98437C2.5529 11.9688 2.20312 11.619 2.20312 11.1875V1.8125C2.20312 1.38103 2.5529 1.03125 2.98438 1.03125H10.0156ZM9.23438 1.8125H10.0156V11.1875H2.98437L2.98438 1.8125H6.10938V5.32812C6.10938 5.48612 6.20455 5.62855 6.35051 5.68902C6.49648 5.74948 6.6645 5.71606 6.77621 5.60434L7.67188 4.70868L8.56754 5.60434C8.67925 5.71606 8.84727 5.74948 8.99324 5.68902C9.1392 5.62855 9.23438 5.48612 9.23438 5.32812V1.8125ZM8.45312 1.8125H6.89062V4.38507L7.39566 3.88004C7.54821 3.72749 7.79554 3.72749 7.94809 3.88004L8.45312 4.38507V1.8125Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.85b010150ec47b684a29913911a83c66.svg";
export { ForwardRef as ReactComponent };